import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthUser } from '../models/auth.models';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Injectable({ providedIn: 'root' })
export class AuthfakeauthenticationService {
    private currentUserSubject: BehaviorSubject<AuthUser>;
    public currentUser: Observable<AuthUser>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<AuthUser>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): AuthUser {
        return this.currentUserSubject.value;
    }

    login(email: string, password: string) {
        var loginUrl = environment.apiurl + "/api/Authentication/authenticate/user/login";
        var user = {};
        console.log({ email, password });
        return this.http.post<any>(loginUrl, { email, password })
            .pipe(map(data => {
                console.log(data);
                if (data.code == 1) {
                    user = data.user;
                    localStorage.setItem('access-token',data.token);
                    if (user) {
                        localStorage.setItem('currentUser', JSON.stringify(user));
                        const expiryTime = new Date().getTime() + (10 * 60 * 60 * 1000); // 10 hours from now in milliseconds
                        localStorage.setItem('texxt', expiryTime.toString()); // Store expiration time
                        var user = {
                            id: user.id,
                            firstName: user.firstName,
                            lastName: user.lastName,
                            profileName: user.profileName,
                            userRoleId: user.userRoleId,
                            userRoleName: user.userRoleName,
                        }
                        this.currentUserSubject.next(user);
                    }

                }else{
                    // Swal.fire('Error', data.message, 'error');
                }
                // login successful if there's a jwt token in the response
                // if (user && user.token) {
                //     // store user details and jwt token in local storage to keep user logged in between page refreshes
                //     localStorage.setItem('currentUser', JSON.stringify(user));
                //     this.currentUserSubject.next(user);
                // }
                return data;
            }));
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }
}
